// extracted by mini-css-extract-plugin
export default {"choose":"I51Gm_G1amBHepu2XC4E","title":"hT9zWx7i0ySj839lyBJt","warning":"iAbLZ74Z40RGjgIp3Ype"};